export default __webpack_public_path__ + "static/media/faq-bg.ac3b2935.jpg";